export class RegisterResponseDTO{
    id!: string;
    code: string | null = null;
    emailVerified: boolean = false;
    message!: string; 
    status!: string;
    
    constructor(data: RegisterResponseDTO){
        Object.assign(this, data);
    }
}